import { useApiQuery } from 'hooks/useApiQuery'

export const useGetAllLicensedEstablishments = () =>
  useApiQuery({
    method: 'get',
    path: '/le-connect/licensed-establishments',
    queryKey: ['licensed-establishments'],
    queryArgs: {},
  })
